// ============================================
// Public API - Re-exports for backward compatibility
// ============================================

// Types
export type {
  JobFeedParams,
  FiltersParams,
  JobCountParams,
  JobIndexParams,
  JobIndexParamsInput,
  JobsApiResponse,
  CreatorJobContext,
  JobSuggestionDto,
  JobSuggestionsResponse,
  JobCountApiResponse,
  JobBySlugResponse,
  PublicFiltersRequest,
  RecommendRequestBody,
  UserSearchRequestBody,
} from "./types";

// Constants
export { defaultJobFeedParams } from "./constants";

// Normalizers
export {
  normalizeCountryCode,
  getCountryLabel,
  normalizeWorkMode,
  getWorkModeLabel,
  normalizeJobType,
  getJobTypeLabel,
  normalizeNicheValue,
  getNicheLabel,
  normalizeSortBy,
  normalizeJobsResponse,
  normalizeJobBySlugResponse,
} from "./normalizers";

// Parameter builders
export { buildJobIndexParams, buildPublicJobParams } from "./paramBuilders";

// Fetchers
export {
  fetchJobs,
  fetchPublicJobs,
  fetchPublicJobCount,
  fetchPublicJobFilters,
  fetchSimilarJobs,
  fetchJobSuggestions,
  fetchJobBySlug,
  fetchFilters,
  fetchJobCount,
  fetchRecommendSearch,
} from "./fetchers";

// React Query hooks (optimized versions)
export {
  useJobsQuery,
  usePublicJobsQuery,
  useFiltersQuery,
  useOptimizedJobCount as useJobCountQuery, // Replace original with optimized version
  useOptimizedJobCount,
  useBatchJobCount,
  usePredictiveJobCount,
  useSmartJobCount,
} from "./hooks";
